/**
 * HHT2 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT2_EP11_ANSWERS = [
    'Matt wants to use the bathroom, but he can’t open the door.',
    'Matt wants Harry to fix the door, but Harry is busy watching a new TV show.',
    'Then, Tony quickly goes into the bathroom.',
    'Meanwhile, Holly and Harry are watching an episode called “Tony’s Tummy Trouble.”',
    'After Tony finishes in the bathroom, he tries to get out. But the door is broken!',
    'Tony continues to cry for help, but Holly and Harry can’t hear him.',
    'After the show finishes, Holly and Harry can hear Tony shouting, “Anybody! Somebody! Help me!”',
    'Holly and Harry rush to the bathroom. Then Harry gets his tools to fix the door.',
    'Soon, Tony is out of the bathroom.',
    'Harry apologizes and explains to Tony, “I was watching your TV show.”',
    'Tony doesn’t get the joke and says, “What are you guys talking about?”',
];

// export const HHT2_EP11_ANSWER_SOUNDS = [
//     '/HHT2_AB EP11_dyr01.mp3',
//     '/HHT2_AB EP11_dyr02.mp3',
//     '/HHT2_AB EP11_dyr03.mp3',
//     '/HHT2_AB EP11_dyr04.mp3',
//     '/HHT2_AB EP11_dyr05.mp3',
//     '/HHT2_AB EP11_dyr06.mp3',
//     '/HHT2_AB EP11_dyr07.mp3',
//     '/HHT2_AB EP11_dyr08.mp3',
//     '/HHT2_AB EP11_dyr09.mp3',
//     '/HHT2_AB EP11_dyr10.mp3',
//     '/HHT2_AB EP11_dyr11.mp3',
// ];

export const HHT2_EP11_ANSWER_SOUNDS = [
    '/38596cadf9a27ed17dcf11982c081a0f.mp3',
    '/36a4430d42f6163b2d909e849b0ae17d.mp3',
    '/1da98ba922a0e347bfc92e72702059e5.mp3',
    '/fa0daa91fa259497d67fe876c62ff5c6.mp3',
    '/5815ff9aace73ed50eec3c195e7057e9.mp3',
    '/b8e4e8f801dfe393512af331dcb496a1.mp3',
    '/61c59bc7c459241b79ff1cf5e7465413.mp3',
    '/f48ad7a92693c24922005a6d7fb059f1.mp3',
    '/7b7ab6b91d93c30855489cdc947741b5.mp3',
    '/bc2dbf3b0ececfd5a690f92032049e85.mp3',
    '/709c95ea7df0076396f699393f8a300c.mp3',
];

export const HHT2_EP11_QUIZ_ITEMS = [{
    'A': HHT2_EP11_ANSWERS[10],
    'B': HHT2_EP11_ANSWERS[1],
    'SoundIndexA': 10,
    'SoundIndexB': 1,
    'answer': HHT2_EP11_ANSWERS[1],
    'sound': [2, 3],
    'exception': false,
},
    {
        'A': HHT2_EP11_ANSWERS[0],
        'B': HHT2_EP11_ANSWERS[4],
        'SoundIndexA': 0,
        'SoundIndexB': 4,
        'answer': HHT2_EP11_ANSWERS[4],
        'sound': [5, 6],
        'exception': false,
    },
    {
        'A': HHT2_EP11_ANSWERS[7],
        'B': HHT2_EP11_ANSWERS[2],
        'SoundIndexA': 7,
        'SoundIndexB': 2,
        'answer': HHT2_EP11_ANSWERS[7],
        'sound': [8],
        'exception': false,
    },
    {
        'A': HHT2_EP11_ANSWERS[9],
        'B': HHT2_EP11_ANSWERS[8],
        'SoundIndexA': 9,
        'SoundIndexB': 8,
        'answer': HHT2_EP11_ANSWERS[9],
        'sound': [10],
        'exception': false,
    },
]
